import React from 'react';
import { Card } from '../../ui/card';
import FilteredRawDataChart from './FilteredRawDataChart';
import SignalQualityChart from './SignalQualityChart';
import PowerSpectrumChart from './PowerSpectrumChart';
import EEGBandPowerCards from './EEGBandPowerCards';
import EEGIndexesChart from './EEGIndexesChart';
import { useTranslation } from '../../../locales';
import { useLanguageStore } from '../../../stores/languageStore';

const EEGVisualizer: React.FC = () => {
  const { currentLanguage } = useLanguageStore();
  const t = useTranslation(currentLanguage);

  return (
    <div className="space-y-6">
      {/* 제목 */}
      <Card className="p-4">
        <h2 className="font-medium mb-2">
          {t.visualizer.eegTitle}
        </h2>
        <p className="text-sm text-muted-foreground">
          {t.visualizer.eegDesc}
        </p>
      </Card>

      {/* 상단: Ch1 필터된 로우 데이터 | Ch2 필터된 로우 데이터 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="p-4">
          <h3 className="font-medium mb-4">
            {t.visualizer.ch1FilteredEEG}
          </h3>
          <div className="text-sm text-muted-foreground mb-4">
            {t.visualizer.ch1FilteredDesc}
          </div>
          <FilteredRawDataChart channel="ch1" />
        </Card>
        
        <Card className="p-4">
          <h3 className="font-medium mb-4">
            {t.visualizer.ch2FilteredEEG}
          </h3>
          <div className="text-sm text-muted-foreground mb-4">
            {t.visualizer.ch2FilteredDesc}
          </div>
          <FilteredRawDataChart channel="ch2" />
        </Card>
      </div>

      {/* 중간: Ch1 SQI | Ch2 SQI */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="p-4">
          <h3 className="font-medium mb-4">
            {t.visualizer.ch1SQI}
          </h3>
          <div className="text-sm text-muted-foreground mb-4">
            {t.visualizer.sqiDesc}
          </div>
          <SignalQualityChart channel="ch1" />
        </Card>
        
        <Card className="p-4">
          <h3 className="font-medium mb-4">
            {t.visualizer.ch2SQI}
          </h3>
          <div className="text-sm text-muted-foreground mb-4">
            {t.visualizer.sqiDesc}
          </div>
          <SignalQualityChart channel="ch2" />
        </Card>
      </div>

      {/* 하단: Power Spectrum | Band Power Cards */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="p-4">
          <h3 className="font-medium mb-4">
            {t.visualizer.powerSpectrum}
          </h3>
          <div className="text-sm text-muted-foreground mb-4">
            {t.visualizer.powerSpectrumDesc}
          </div>
          <PowerSpectrumChart />
        </Card>
        
        <Card className="p-4">
          <h3 className="font-medium mb-4">
            {t.visualizer.bandPower}
          </h3>
          <div className="text-sm text-muted-foreground mb-4">
            {t.visualizer.bandPowerDesc}
          </div>
          <EEGBandPowerCards />
        </Card>
      </div>

      {/* 최하단: EEG 분석 지수 (전체 폭) */}
      <Card className="p-4">
        <h3 className="font-medium mb-4">
          {t.visualizer.eegIndexes}
        </h3>
        <div className="text-sm text-muted-foreground mb-4">
          {t.visualizer.eegIndexesDesc}
        </div>
        <EEGIndexesChart />
      </Card>
    </div>
  );
};

export default EEGVisualizer;
